export default import.meta.ROLLDOWN_FILE_URL_VRAku6fjghkApIISiBWPzg_81f041d7432aa3fbda657981